// extracted by mini-css-extract-plugin
export default {"wrapper":"FormAdmin_wrapper__DetPu","menu":"FormAdmin_menu__8GGZG","contentAdmin":"FormAdmin_contentAdmin__1N43u"};